import React from 'react';
import { useState, useCallback, useMemo } from 'react';
import { Form } from 'react-bootstrap';
import claimEmployeesService from '../../services/claim/claim_employees.service';
import { handleError } from '@rd-web-markets/shared/dist/store/features/alertSlice';
import { useDispatch, useSelector } from 'react-redux';
import ChangeHighlightedImmutableUnderReviewControl from '@rd-web-markets/shared/dist/util/reviewEditControls/ChangeHighlightedImmutableUnderReviewControl';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
export const EmployeeBioRow = _ref => {
  let {
    index,
    claim,
    handleAdd,
    handleDelete,
    claimEmployees,
    setClaimEmployees
  } = _ref;
  const claimEmployee = useMemo(() => {
    return {
      ...claimEmployees[index]
    };
  }, [claimEmployees, index]);
  const [hasError, setHasError] = useState(false);
  const dispatch = useDispatch();
  const user = useSelector(state => state.auth.user);
  const updateEmployees = useCallback(employee => {
    const newEmployees = [...claimEmployees];
    newEmployees[index] = {
      ...employee
    };
    setClaimEmployees([...newEmployees]);
  }, [claimEmployees, index, setClaimEmployees]);
  const confirmAndDelete = async index => {
    if (window.confirm('Are you sure you wish to delete this employee?')) {
      try {
        await handleDelete(index);
      } catch (error) {
        dispatch(handleError(error));
      }
    }
  };
  const handleChange = useCallback(async event => {
    const value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    claimEmployee[event.target.name] = value;
    await updateEmployees(claimEmployee);
  }, [updateEmployees, claimEmployee]);
  const saveChange = useCallback(() => {
    let method;
    if (claimEmployee.id) {
      method = 'update';
    } else {
      method = 'create';
    }
    claimEmployeesService[method](claimEmployee).then(updatedEmployee => {
      updateEmployees(updatedEmployee);
      setHasError(false);
    }).catch(e => {
      setHasError(true);
      dispatch(handleError(e));
    });
  }, [updateEmployees, claimEmployee, dispatch]);
  const hasPermissions = () => {
    return user.account_type !== 'customer' && user.account_type !== 'accountant';
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("tr", {
    className: hasError ? 'bg-warning' : ''
  }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked || !hasPermissions(),
    name: "name",
    type: "text",
    className: "mb-3",
    size: "sm"
  }), /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked || !hasPermissions(),
    name: "role",
    type: "text",
    placeholder: "Please enter employees role",
    size: "sm"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Control,
    onChange: e => handleChange(e, index),
    onBlur: saveChange,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    disabled: claim.financials_locked || !hasPermissions(),
    name: "bio",
    placeholder: "Please enter employees experience and relevant qualifications",
    type: "text",
    controlAs: "textarea",
    rows: "3"
  })), /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement("div", {
    className: "d-flex"
  }, /*#__PURE__*/React.createElement(ChangeHighlightedImmutableUnderReviewControl, {
    as: Form.Check,
    object: {
      ...claimEmployee,
      claim: {
        ...claim,
        ...claimEmployee.claim
      }
    },
    name: "include_in_technical_report",
    onChange: async e => {
      await handleChange(e, index);
      saveChange();
    },
    label: "Include within R&D Report",
    className: "mb-1 col-form-label",
    disabled: claim.financials_locked || !hasPermissions()
  }), hasPermissions() && /*#__PURE__*/React.createElement(DeleteButton, {
    className: "ms-4 text-warning",
    variant: "secondary",
    disabled: claim.is_locked || claim.financials_locked || claim.active_change_set,
    isImmutableUnderReview: true,
    onClick: () => confirmAndDelete(index)
  })))));
};